import { ModelApiName } from 'api/Exec/types';
import usePdfPrsReportTypes from 'app/hooks/usePdfPrsReportTypes';

import { Form, Select } from 'antd';
import React from 'react';

interface Props {
  isLoading: boolean;
  modelApiName: ModelApiName
}

const PdfReportTypesSelect: React.FC<Props> = ({ isLoading, modelApiName }) => {
  const { reportTypeOptions } = usePdfPrsReportTypes();

  return reportTypeOptions.length > 0 && modelApiName === 'mysterio' ? (
    <Form.Item name="reportTypes" label="Report type" rules={[ { required: true, message: 'Field is mandatory' } ]}>
      <Select
        mode="multiple"
        placeholder="Select report type"
        options={reportTypeOptions}
        disabled={isLoading}
        showSearch={false}
      />
    </Form.Item>
  ) : null;
};

export default PdfReportTypesSelect;
